"use client";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["ownerDocument"],
  _excluded2 = ["enabled", "ownerDocument"],
  _excluded3 = ["target"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import i, { Fragment as R, createContext as E, useContext as P, useEffect as A, useMemo as G, useRef as x, useState as M } from "react";
import { createPortal as b } from "react-dom";
import { useDisposables as O } from '../../hooks/use-disposables.js';
import { useEvent as L } from '../../hooks/use-event.js';
import { useOnUnmount as F } from '../../hooks/use-on-unmount.js';
import { useOwnerDocument as H } from '../../hooks/use-owner.js';
import { optionalRef as h, useSyncRefs as T } from '../../hooks/use-sync-refs.js';
import { usePortalRoot as U } from '../../internal/portal-force-root.js';
import { env as N } from '../../utils/env.js';
import { forwardRefWithAs as f, useRender as d } from '../../utils/render.js';
function W(e) {
  let o = U(),
    l = P(c),
    [r, p] = M(() => {
      var s;
      if (!o && l !== null) return (s = l.current) != null ? s : null;
      if (N.isServer) return null;
      let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
      if (t) return t;
      if (e === null) return null;
      let n = e.createElement("div");
      return n.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(n);
    });
  return A(() => {
    r !== null && (e != null && e.body.contains(r) || e == null || e.body.appendChild(r));
  }, [r, e]), A(() => {
    o || l !== null && p(l.current);
  }, [l, p, o]), r;
}
let _ = R,
  j = f(function (o, l) {
    let {
        ownerDocument: r = null
      } = o,
      p = _objectWithoutProperties(o, _excluded),
      t = x(null),
      n = T(h(a => {
        t.current = a;
      }), l),
      s = H(t.current),
      C = r != null ? r : s,
      u = W(C),
      y = P(m),
      g = O(),
      v = d();
    return F(() => {
      var a;
      u && u.childNodes.length <= 0 && ((a = u.parentElement) == null || a.removeChild(u));
    }), u ? b(i.createElement("div", {
      "data-headlessui-portal": "",
      ref: a => {
        g.dispose(), y && a && g.add(y.register(a));
      }
    }, v({
      ourProps: {
        ref: n
      },
      theirProps: p,
      slot: {},
      defaultTag: _,
      name: "Portal"
    })), u) : null;
  });
function S(e, o) {
  let l = T(o),
    {
      enabled: r = !0,
      ownerDocument: p
    } = e,
    t = _objectWithoutProperties(e, _excluded2),
    n = d();
  return r ? i.createElement(j, _objectSpread(_objectSpread({}, t), {}, {
    ownerDocument: p,
    ref: l
  })) : n({
    ourProps: {
      ref: l
    },
    theirProps: t,
    slot: {},
    defaultTag: _,
    name: "Portal"
  });
}
let I = R,
  c = E(null);
function D(e, o) {
  let {
      target: l
    } = e,
    r = _objectWithoutProperties(e, _excluded3),
    t = {
      ref: T(o)
    },
    n = d();
  return i.createElement(c.Provider, {
    value: l
  }, n({
    ourProps: t,
    theirProps: r,
    defaultTag: I,
    name: "Popover.Group"
  }));
}
let m = E(null);
function ee() {
  let e = P(m),
    o = x([]),
    l = L(t => (o.current.push(t), e && e.register(t), () => r(t))),
    r = L(t => {
      let n = o.current.indexOf(t);
      n !== -1 && o.current.splice(n, 1), e && e.unregister(t);
    }),
    p = G(() => ({
      register: l,
      unregister: r,
      portals: o
    }), [l, r, o]);
  return [o, G(() => function (_ref) {
    let {
      children: n
    } = _ref;
    return i.createElement(m.Provider, {
      value: p
    }, n);
  }, [p])];
}
let J = f(S),
  X = f(D),
  te = Object.assign(J, {
    Group: X
  });
export { te as Portal, X as PortalGroup, ee as useNestedPortals };